import { render, staticRenderFns } from "./CustomerCertificatesView.vue?vue&type=template&id=068c857a&"
import script from "./CustomerCertificatesView.vue?vue&type=script&lang=js&"
export * from "./CustomerCertificatesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports